exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vehicleContainer {\n  height: 98vh;\n  border: solid 1px #B6C2E2;\n  margin: 0 20px;\n  align-content: flex-start;\n  width: auto !important;\n  border-radius: 7px;\n}\n\n.vehiculeItem:hover {\n  background-color: #E0E0E0 !important;\n  cursor: pointer;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #4F9C20;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n  border-radius: 10px;\n}\n\n.css-v5tqd1-MuiButtonBase-root-MuiButton-root {\n  padding: 6px 12px !important;\n}", ""]);

// exports
